/**
 *
 * @module customerServiceManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class CustomerServiceManagerConfiguration
 *
 */
export default class CustomerServiceManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/customerServiceManagerConfiguration.js